const requestOrderAndTradeinLookupEmail = async (partnerUuid, email) => {
  const query = `
    mutation requestOrderAndTradeinLookupEmailFetch(
      $email: String!
      $partnerUuid: String!
    ) {
      requestOrderAndTradeinLookupEmail(
          partnerUuid: $partnerUuid
          email: $email
        ) {
        deliveredTo
      }
    }
  `;
  const param = 'query-requestOrderAndTradeinLookupEmail';
  try {
    const response = await fetchWithAppName(`${global.url}${param}`, {
      body: JSON.stringify({ query, variables: { partnerUuid, email } }),
    });

    const jsonData = await response.json();
    return jsonData.data.requestOrderAndTradeinLookupEmail;
  } catch (e) {
    console.error(e);
    return null;
  }
};

const form = document.getElementById('order-lookup-form');
const emailInput = document.getElementById('order-lookup__input');
const submitButton = document.getElementById('order-lookup__submit-button');
const successMessage = document.getElementById('order-lookup__success-message');
const errorMessage = document.getElementById('order-lookup__error-message');
const invalidEmailMessage = document.getElementById('order-lookup__invalid-email-message');

const submitOrderAndTradeInLookup = async (e) => {
  e.preventDefault();
  const email = emailInput.value;

  successMessage.classList.add('hidden');
  errorMessage.classList.add('hidden');
  submitButton.setAttribute('disabled', '');

  if (form.checkValidity()) {
    const response = await requestOrderAndTradeinLookupEmail(global.partnerUuid, email);
  
    if (response && response.deliveredTo.length > 0) {
      successMessage.classList.remove('hidden');
    } else {
      errorMessage.classList.remove('hidden');
    }
  }

  submitButton.removeAttribute('disabled');
}

const toggleInputErrorMessage = (show = false) => {
  if (emailInput.validity?.valid) {
    invalidEmailMessage.classList.add('hidden');
  } else if (show) {
    invalidEmailMessage.classList.remove('hidden');
  }
}

emailInput.addEventListener('keydown', (e) => {
  if (e.key === 'Enter') {
    toggleInputErrorMessage(true);
    submitOrderAndTradeInLookup(e);
  }
});

form.addEventListener('input', function (e) {
  toggleInputErrorMessage();
  toggleSubmitButton();
});

submitButton.addEventListener('click', submitOrderAndTradeInLookup);
submitButton.addEventListener('keypress', (event) => a11yKeyPress(event, submitOrderAndTradeInLookup));

const toggleSubmitButton = () => {
  submitButton.disabled = !form.checkValidity();
}